import View from "./View.vue"
import DynamicNode from "../Dynamic.js"

export default DynamicNode({
  name: 'Stats',

  group: 'block',

  atomic: true,

  draggable: true,
}, View)
